<div
  class="origin"
  cdkOverlayOrigin
  #menuOrigin="cdkOverlayOrigin"
></div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="menuOrigin"
  [cdkConnectedOverlayOpen]="true"
  [cdkConnectedOverlayPush]="overlayPush"
  [cdkConnectedOverlayLockPosition]="overlayLockPosition"
  [cdkConnectedOverlayViewportMargin]="viewportMargin"
  [cdkConnectedOverlayPositions]="overlayPositions"
  cdkConnectedOverlayPanelClass="popover-menu-overlay"
>
  <div
    #menuOverlay
    class="menu"
    role="menu"
  >
    @if (menuTitle) {
      <div class="menu-item title">
        {{menuTitle}}
      </div>
    }

    @for (option of options; track option.id) {
      <a
        [attr.data-id]="option.id"
        [routerLink]="option.href ?? null"
        [queryParams]="option.params"
        role="menuitem"
        [ngClass]="{
          'menu-item': true,
          'selected': option.selected,
          'indigo': hoverColor === 'indigo',
          'indigo-dark': hoverColor === 'indigo-dark',
          'green': hoverColor === 'green'
        }"
        (click)="onClick(option)"
      >
        <div class="text">
          @if (option.icon) {
            <i class="{{option.icon.includes(' ') ? option.icon : 'fa-regular fa-fw fa-' + option.icon}}" style="margin-right: 2px;"></i>
          }
          {{option.name}}
        </div>
      </a>
    }
  </div>
</ng-template>
